import { Site } from '@envato/foundation-types'

const experimentConfig = {
  categoryRedesignPhase3Experiment: {
    experimentId: 'W19Qql2yS0-11u9fOpSAQw',
    running: false,
    loadingCover: true,
    sites: [Site.themeforest],
    variants: {
      0: {
        categoryRedesign: false
      },
      1: {
        categoryRedesign: false
      },
      2: {
        categoryRedesign: true
      },
      3: {
        categoryRedesign: true
      }
    }
  },
  categoryRedesignVHPhase1Experiment: {
    experimentId: 'ofiarUu8RbqYFuRwmfb7zQ',
    running: true,
    loadingCover: true,
    sites: [Site.videohive],
    variants: {
      0: {
        categoryRedesign: false
      },
      1: {
        categoryRedesign: false
      },
      2: {
        categoryRedesign: true
      },
      3: {
        categoryRedesign: true
      }
    }
  },
  categoryRedesignAJPhase1Experiment: {
    experimentId: 'kKmVKGGGR4iNXSkvMQyY1Q',
    running: true,
    loadingCover: true,
    sites: [Site.audiojungle],
    variants: {
      0: {
        categoryRedesign: false
      },
      1: {
        categoryRedesign: false
      },
      2: {
        categoryRedesign: true
      },
      3: {
        categoryRedesign: true
      }
    }
  },
  categoryRedesignCCPhase1Experiment: {
    experimentId: 'Dsf-v35pQFKNq1DNy6nyww',
    running: true,
    loadingCover: true,
    sites: [Site.codecanyon],
    variants: {
      0: {
        categoryRedesign: false
      },
      1: {
        categoryRedesign: false
      },
      2: {
        categoryRedesign: true
      },
      3: {
        categoryRedesign: true
      }
    }
  },
  categoryRedesignGRPhase1Experiment: {
    experimentId: 'IUzmtORZSpuIN_OtC6n4Vg',
    running: true,
    loadingCover: true,
    sites: [Site.graphicriver],
    variants: {
      0: {
        categoryRedesign: false
      },
      1: {
        categoryRedesign: false
      },
      2: {
        categoryRedesign: true
      },
      3: {
        categoryRedesign: true
      }
    }
  },
  categoryRedesignTFPhase4Experiment: {
    experimentId: 'R_qk8EJ2Qzuj9y78ysRAjA',
    running: true,
    loadingCover: true,
    sites: [Site.themeforest],
    variants: {
      0: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false
      },
      1: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false
      },
      2: {
        categoryPageBlocksB: true,
        categoryPageBlocksC: false
      },
      3: {
        categoryPageBlocksB: true,
        categoryPageBlocksC: false
      },
      4: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: true
      },
      5: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: true
      }
    }
  },
  categoryRedesignVHPhase2Experiment: {
    experimentId: 'whz7LWAXRE2MLh7mYT-aZw',
    running: false,
    loadingCover: true,
    sites: [Site.videohive],
    variants: {
      0: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false
      },
      1: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false
      },
      2: {
        categoryPageBlocksB: true,
        categoryPageBlocksC: false
      },
      3: {
        categoryPageBlocksB: true,
        categoryPageBlocksC: false
      },
      4: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: true
      },
      5: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: true
      }
    }
  },
  authorDiscountingItemsPhase1: {
    experimentId: 'kT4ZPZugQPSUM-qZH6fqhw',
    running: false,
    loadingCover: true,
    sites: [Site.themeforest],
    variants: {
      0: {
        showPromoItemsBlock: false,
        showWasNowPricing: false
      },
      1: {
        showPromoItemsBlock: false,
        showWasNowPricing: false
      },
      2: {
        showPromoItemsBlock: true,
        showWasNowPricing: false
      },
      3: {
        showPromoItemsBlock: true,
        showWasNowPricing: false
      },
      4: {
        showPromoItemsBlock: true,
        showWasNowPricing: true
      },
      5: {
        showPromoItemsBlock: true,
        showWasNowPricing: true
      }
    }
  }
}

export default experimentConfig
